import { useInfiniteQuery } from '@tanstack/react-query';

import { Users } from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';

import { getNextPageParam, usersCacheKeys } from './utils';

type ListUsersParams = {
    primaryYat?: string;
    twitterHandle?: string;
    isAuthenticated: boolean;
    limit?: number;
};

/**
 * Get a list of users using primaryYat and/or twitter handle to filter
 */

export function useListUsers({ primaryYat, twitterHandle, isAuthenticated = true, limit }: ListUsersParams) {
    return useInfiniteQuery(
        usersCacheKeys.users(primaryYat, twitterHandle),
        ({ signal, pageParam = 0 }) =>
            apiFactory()
                .call(Users.listUsers, {
                    primaryYat,
                    twitterHandle,
                    query: { limit, page: pageParam || 0 },
                    settings: {
                        credentials: isAuthenticated ? 'include' : 'omit',
                        signal,
                    },
                })
                .then((result) => {
                    if (result.ok) {
                        return result.value;
                    }
                    const errorMessage = result?.error?.detail ?? `Error getting users`;
                    throw new Error(errorMessage);
                }),
        {
            retry: false,
            keepPreviousData: true,
            enabled: Boolean(primaryYat || twitterHandle),
            getNextPageParam,
        },
    );
}
